import axios from "../../axios/index.js"


export default {
  AddNewCirculaire(body){
    return axios.post("/newCirculaire", body, 
    { headers: { Authorization: 'Bearer ' + localStorage.getItem("accessToken") } });
  },
  Add(circulaireData) {
      console.log(circulaireData)
      let formData = new FormData();
      formData.append("file", circulaireData.file)
      formData.append("title", circulaireData.title)
    return axios.post("circulaire", formData,
    { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
  // 
  findCirculaire(id){
    return axios.get("findCirculaire/" + id ,
    { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  },
/*   getFileContent(id){
    return axios.get("fileContent/" + id ,
    { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
  }, */
  getAll() {
  return axios.get("circulaire",
  { headers: { Authorization: 'Bearer ' + localStorage.getItem('accessToken') } })
},
}
